<template>
  <div class="z_index">
  <float-win v-if="WinShow"
            :titleurl="{
              title: Wintitle,
              url: WinUrl,
            }"
          >
  </float-win>
    <div class="z-content">
      <div class="z-content-statistics">
        <ul>
          <li>
            <div class="statistics-item">
              <div style="float: left">
                <svg-icon className="statistics-svg" icon-class="data1" />
              </div>
              <div style="float: left; margin-left: 16px">
                <div>入驻会员</div>
                <!-- <span style="font-weight: 500; color: #f5222d; font-size: 24px">
                  {{ Statistics.count_member }}
                </span> -->
                <span
                  ref="countup"
                  style="font-weight: 500; font-size: 24px"
                  class="z_home_statistics_color"
                  >000</span
                >
                <span style="font-size: 13px"> 家</span>
              </div>
            </div>
          </li>
          <li>
            <div class="statistics-item">
              <div style="float: left">
                <svg-icon className="statistics-svg" icon-class="data2" />
              </div>
              <div style="float: left; margin-left: 16px">
                <div>成交项目</div>
                <!-- <span style="font-weight: 500; color: #f5222d; font-size: 24px">
                  {{ Statistics.count_project }}
                </span> -->
                <span
                  ref="countup1"
                  style="font-weight: 500; font-size: 24px"
                  class="z_home_statistics_color"
                  >000</span
                >
                <span style="font-size: 13px"> 个</span>
              </div>
            </div>
          </li>
          <li>
            <div class="statistics-item">
              <div style="float: left">
                <svg-icon className="statistics-svg" icon-class="data3" />
              </div>
              <div style="float: left; margin-left: 16px">
                <div>成交金额</div>
                <!-- <span style="font-weight: 500; color: #f5222d; font-size: 24px">
                  {{ Statistics.count_money }}
                </span> -->
                <span
                  ref="countup2"
                  style="font-weight: 500; font-size: 24px"
                  class="z_home_statistics_color"
                  >00.00</span
                >
                <span style="font-size: 13px"> 万元</span>
              </div>
            </div>
          </li>
          <li>
            <div class="statistics-item">
              <div style="float: left">
                <svg-icon className="statistics-svg" icon-class="data3" />
              </div>
              <div style="float: left; margin-left: 16px">
                <div>节约资金</div>
                <!-- <span style="font-weight: 500; color: #f5222d; font-size: 24px">
                  {{ Statistics.count_savedMoney }}
                </span> -->
                <span
                  ref="countup3"
                  style="font-weight: 500; font-size: 24px"
                  class="z_home_statistics_color"
                  >00.00</span
                >
                <span style="font-size: 13px"> 万元</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="z-content-entrance">
        <!-- 采购人-代理-投标人-专家-->
        <ul class="z-entrance">
          <li>
            <a
              href="https://ygcg.nbcqjy.org:8070/login?client_id=449abf125e27f3d8a3746004b59eb154&client_secret=d615b54a6ade7f99a119604fa32a75b6e765ee3cfea10d7bd8bf2530c6b691db&response_type=code&redirect_uri=https%3A%2F%2Fygcg.nbcqjy.org%3A8069%2FAuthorization%2FAuth.html&SystemName=%E4%BA%A4%E6%98%93%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F"
              target="_blank"
            >
              <img src="../../assets/link_u2.png" />
            </a>
          </li>
          <li>
            <a
              href="https://ygcg.nbcqjy.org:8070/login?client_id=449abf125e27f3d8a3746004b59eb154&client_secret=d615b54a6ade7f99a119604fa32a75b6e765ee3cfea10d7bd8bf2530c6b691db&response_type=code&redirect_uri=https%3A%2F%2Fygcg.nbcqjy.org%3A8069%2FAuthorization%2FAuth.html&SystemName=%E4%BA%A4%E6%98%93%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F"
              target="_blank"
            >
              <img src="../../assets/link_u3.png" />
            </a>
          </li>
          <li>
            <a href="https://ygcg.nbcqjy.org:8071/login.html" target="_blank">
              <img src="../../assets/link_u1.png" />
            </a>
          </li>
          <li>
            <a
              href="http://ygcg.nbcqjy.org:8057/login.html?CustomerId=0000"
              target="_blank"
            >
              <img src="../../assets/link_u5.png" />
            </a>
          </li>
          <li>
            <!-- href="https://nbcq.jslink.com" -->
            <a
              href="https://zcsc.nbcqjy.org/"
              target="_blank"
            >
              <img src="../../assets/link_u6.png" />
            </a>
          </li>
          <!-- <li>
            <a
              href="http://ygcg.nbcqjy.org:8060/login?client_id=449abf125e27f3d8a3746004b59eb154&client_secret=d615b54a6ade7f99a119604fa32a75b6e765ee3cfea10d7bd8bf2530c6b691db&response_type=code&redirect_uri=http%3A%2F%2F47.97.190.124%3A8059%2FAuthorization%2FAuth.html&SystemName=电子监管系统"
              target="_blank"
            >
              <img src="../../assets/link_u4_2x.png" />
            </a>
          </li> -->
        </ul>
      </div>
      <div>
        <div class="z-content-left">
          <z-card
            class="news"
            style="height: 300px; margin-bottom: 10px"
            :titleparam="{
              iconname: 'nav_header4',
              iconclass: 'card-title',
              title: '新闻动态',
              morelink: '/list?type=5&class=8',
            }"
            @cardbtncallback="cardbtncallback"
          >
            <div style="white-space: nowrap">
              <div
                style="
                  display: inline-block;
                  width: 350px;
                  vertical-align: text-top;
                "
              >
                <Carousel autoplay>
                  <div v-for="item in newsImgList" :key="item.articleId">
                    <router-link
                      :to="{
                        name: 'detail',
                        query: { newsId: item.articleId },
                      }"
                      target="_blank"
                    >
                      <div style="height: 233px;width: 350px;overflow: hidden;">
                        <img :src="item.img_url">
                      </div>
                    </router-link>
                    <p
                      style="
                        display: block;
                        position: absolute;
                        height: 34px;
                        width: 350px;
                        background: linear-gradient(to right, #b53131 0%,#b53131 1.5%,rgb(0 0 0 / 80%) 1.5%,rgb(0 0 0 / 80%) 100%);
                        bottom: -9px;
                        color: white;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        line-height: 34px;
                        padding-left: 11px;
                        padding-right: 90px;
                      "
                    >
                      {{ item.title }}
                    </p>
                  </div>
                </Carousel>
              </div>
              <div
                style="
                  display: inline-block;
                  width: calc(100% - 370px);
                  margin-left: 20px;
                  margin-top: -1px;
                  white-space: nowrap;
                  vertical-align: text-top;
                "
              >
                <ul class="z-list" style="border-top: 1px solid #e8e8e8">
                  <li v-for="item in newsList" :key="item.articleId">
                    <div style="width: 200px" class="z-list-title">
                      <router-link
                        :to="{
                          name: 'detail',
                          query: { newsId: item.articleId},
                        }"
                        target="_blank"
                      >
                        <span
                          style="
                            width: 290px;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                          "
                          class="z_list_title_span"
                        >
                        <!-- <span data-v-5954443c="" v-if="item.onTop==1" style="margin-right:0" class="z-tag D02">置顶 </span> -->
                          {{ item.title }}
                        </span>
                      </router-link>
                    </div>
                    <span style="float: right; color: #8c8c8c">
                      {{ item.publishDate | moment_d }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </z-card>
          <z-card
            style="height: 668px"
            :titleparam="{
              iconname: 'nav_header4',
              iconclass: 'card-title',
              title: '公告公示',
              morelink: '/list?type=2&class=公告公示&noticeType=' + NoticeType,
            }"
            :btngroup="btngroup"
            @cardbtncallback="cardbtncallback"
          >
            <ul class="z-list" style="border-top: 1px solid #e8e8e8">
              <li v-for="item in BulletinList" :key="item.autoId" style="display: flex;justify-content: space-between;width: 100%;">
                <div class="z-list-title">
                  <router-link
                    :to="{
                      name: 'detail',
                      query: { bulletinId: item.autoId },
                    }"
                    target="_blank"
                  >
                    <span
                      v-show="item.infoTypeId"
                      :class="'z-tag ' + item.infoTypeId"
                      >{{
                        item.infoTypeId == "D01"
                          ? "货物"
                          : item.infoTypeId == "D02"||item.infoTypeId == "D05"||item.infoTypeId == "D06"
                          ? "工程"
                          : item.infoTypeId == "D03"
                          ? "服务"
                          : item.infoTypeId == "D07"
                          ? "中介"
                          : "其他"
                      }}
                    </span>
                    <span
                      v-show="item.prjNo"
                      :title="item.prjNo"
                      style="width: 120px; margin-right: 8px"
                      class="z_list_title_span"
                    >
                      {{ item.prjNo }}
                    </span>
                    <span
                      :title="item.bulletinTitle"
                      :style="item.prjNo ? 'width: 450px' : ''"
                      class="z_list_title_span"
                    >
                      {{ item.bulletinTitle }}
                    </span>
                  </router-link>
                </div>

                <span style="float: right; color: #8c8c8c">
                  {{ item.publishDate | moment_d }}
                </span>
              </li>
            </ul>
          </z-card>

          <div style="margin-top: 16px">
            <img src="../../assets/ad_800_96.png" />
          </div>

          <z-card
            style="margin-top: 16px; height: 692px"
            :titleparam="{
              iconname: 'nav_header4',
              iconclass: 'card-title',
              title: '竞价大厅',
              morelink: '/biddinglist?biddingType=' + biddingType,
            }"
            :btngroup="btngroupbid"
            @cardbtncallback="biddingCallback"
          >
            <div style="border-top: 1px solid #e8e8e8">
              <div
                v-if="
                  biddingType === 0 || biddingType === 1 || biddingType === 2
                "
              >
                <div
                  @click="Bullet(item.prjId,item.ztbTypeId)"
                  v-for="item in biddingList"
                  :key="item.prjId"
                  class="bid-card"
                >
                  <div title="立即报价" class="bid-card-container">
                    <div class="bid-card-head">
                      <div class="bid-card-prjname">{{ item.prjName }}</div>
                      <div class="bid-card-alert" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        <svg-icon
                          style="margin-left: 12px"
                          className="bid-card-svg"
                          icon-class="jjgs"
                        />
                        {{ item.yzCompanyName }}
                      </div>
                    </div>
                    <div class="bid-card-body">
                      <!-- {{ item.prjContent }} -->
                      <ul>
                        <li>
                          <div>
                            <span class="catalogue">品目分类：</span
                            ><span class="catalogue_span">
                              {{ item.callingName }}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">项目编号：</span
                            ><span class="catalogue_span">{{
                              item.prjNo
                            }}</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">竞价方式：</span>
                            <span class="catalogue_span">
                              <span v-if="item.ztbTypeId==='0207'"  :class="'z-tag D02'"
                              >电子询价
                            </span>
                              <span v-if="item.ztbTypeId==='0208'"   :class="'z-tag D01'"
                              >电子竞价
                            </span>
                              <span v-if="item.ztbTypeId==='0210'"  :class="'z-tag D03'"
                              >电子比选
                            </span>
                              </span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">预算价格：</span
                            ><span class="catalogue_span"
                              >{{ item.basePrice | NumberFormat }} 元</span
                            >
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">发布日期：</span
                            ><span class="catalogue_span"
                              >{{ item.signUpDate | moment_d }}</span
                            >
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="bid-card-footer">
                      <div
                        v-if="!getcountdown(item.kbDate).showcountdown||item.state==4"
                        style="
                          text-align: center;
                          color: #f95965;
                          font-weight: bold;
                        "
                      >
                        <span>报价结束</span>
                      </div>
                      <div
                        v-else-if="item.state==6"
                        style="
                          text-align: center;
                          color: #f95965;
                          font-weight: bold;
                        "
                      >
                        <span>已暂停</span>
                      </div>
                      <div
                        v-else
                        class="bid-card-footer-countdown"
                      >
                      <span>报价结束倒计时</span>
                        <span class="footer-time" style="margin-left: 8px">{{
                          getcountdown(item.kbDate).days
                        }}</span>
                        <span>天</span>
                        <span class="footer-time">{{
                          getcountdown(item.kbDate).hours
                        }}</span>
                        <span>时</span>
                        <span class="footer-time">{{
                          getcountdown(item.kbDate).minutes
                        }}</span>
                        <span>分</span>
                      </div>
                    </div>
                    <div
                      v-if="biddingType === 1"
                      :class="
                        item.minFinallyPrice != 0 ? 'bid-card-footer-price' : ''
                      "
                    >
                      <div v-show="item.minFinallyPrice != 0">
                        <div class="price-div">
                          <span style="margin-left: 8px">¥</span>
                          <span class="pricespan"
                            >{{ item.minFinallyPrice | NumberFormat }} 元</span
                          >
                        </div>

                        <div class="skewX">
                          <div>当前最低报价</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="bid-card-footer-btn">
                      <div v-if="!getcountdown(item.kbDate).showcountdown||item.state==4||item.state==6">
                      <button @click="Bullet(item.prjId,item.ztbTypeId)">详情</button>
                      </div>
                      <div v-else>
                        <button @click.stop="Offer(item.prjId)">立即报价</button>
                      </div>
                    </div>
                  </div>
                  <img style="position: absolute;top: 155px;right: 10px;" v-if="!getcountdown(item.kbDate).showcountdown||item.state==4" src="../../assets/status3.png" alt="">
                </div>
              </div>
              <div v-else-if="biddingType === 3">
                <ul class="z-list" style="border-top: 1px solid #e8e8e8">
                  <li v-for="item in biddingResult" :key="item.prjNo">
                    <div class="z-list-title" style="width: auto">
                      <!-- <router-link
                        :to="{
                          name: 'detail',
                          query: { bulletinId: item.autoId },
                        }"
                      > -->
                      <span :class="'z-tag ' + getClass(item.ztbTypeId)"
                        >{{ item.ztbTypeName }}
                      </span>

                      <span
                        v-show="item.prjNo"
                        :title="item.prjNo"
                        style="width: 150px; margin-right: 8px"
                        class="z_list_title_span"
                      >
                        <a @click="Bullet2(item.prjId)">{{ item.prjNo }}</a>
                      </span>
                      <a @click="Bullet2(item.prjId)">
                      <span
                        :title="item.prjName"
                        :style="item.prjNo ? 'width: 450px' : ''"
                        class="z_list_title_span"
                      >
                        {{ item.prjName }}
                      </span>
                      </a>

                      <!-- <span class="z_list_title_span">
                        <a @click="Bullet2(item.prjId)">{{ item.prjNo }}</a>
                      </span>
                      <span class="z_list_title_span">
                        <a @click="Bullet2(item.prjId)">{{ item.prjName }}</a>
                      </span> -->
                      <!-- <span style="width: 200px" class="z_list_title_span">
                        {{ item.zb_customer }}
                      </span> -->
                      <!-- </router-link> -->
                    </div>
                    <div style="float: right; color: #8c8c8c">
                      <!-- <span style="margin-right: 16px">
                        {{ item.finallyPrice | NumberFormat }}
                      </span> -->
                      <span>
                        {{ item.closeDate | moment_d }}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="clear"></div>
          </z-card>
          <!-- 广告位招商 -->
          <!-- <div style="margin-top: 16px">
            <img style="width: 392px" src="../../assets/ad_392_112_2x.png" />
            <img
              style="width: 392px; margin-left: 16px"
              src="../../assets/ad_392_112_2x.png"
            />
          </div> -->
        </div>

        <!-- 右侧内容区 -->
        <div class="z-content-right">
          <z-card
            style="margin-bottom: 10px; height: 106px"
            :titleparam="{
              iconname: 'nav_header11',
              iconclass: 'card-title',
              title: '电子监督',
              dzdc:DZJGList.total
            }"
          >
          <a href="https://ygcg.nbcqjy.org:8070/login?client_id=449abf125e27f3d8a3746004b59eb154&client_secret=d615b54a6ade7f99a119604fa32a75b6e765ee3cfea10d7bd8bf2530c6b691db&response_type=code&redirect_uri=https%3A%2F%2Fygcg.nbcqjy.org%3A8069%2FAuthorization%2FAuth.html&SystemName=%E7%94%B5%E5%AD%90%E7%9B%91%E7%9D%A3%E7%B3%BB%E7%BB%9F" target="_blank">
          <div style="width: auto;display: inline-block;margin-left: 60px;">
              <div class="green"
              style="margin-right: 10px;text-align: center;display: inline-block;">
            </div>
            <div style="margin-right: 25px;margin-top: 4px;text-align: center;height: 30px;width: 39px;display: inline-block;vertical-align: top;">
              <label style="color:black">{{DZJGList.greenTotal}}</label>
            </div>
              <div class="yellow"
                  style="margin-right: 10px;text-align: center;display: inline-block;vertical-align: top;">
              </div>
              <div style="margin-right: 25px;margin-top: 4px;text-align: center;height: 30px;width: 39px;display: inline-block;vertical-align: top;">
                  <label style="color:black">{{DZJGList.yellowTotal}}</label>
              </div>
              <div class="red"
                  style="margin-right: 10px;text-align: center;display: inline-block;vertical-align: top;">
              </div>
                      <div style="margin-right: 10px;margin-top: 4px;text-align: center;height: 30px;width: 39px;display: inline-block;vertical-align: top;">
                          <label style="color:black">{{DZJGList.redTotal}}</label>
                      </div>
          </div></a>
          
          </z-card>
          <z-card
            style="margin-bottom: 10px; height: 224px"
            :titleparam="{
              iconname: 'nav_header3',
              iconclass: 'card-title',
              title: '平台动态',
              morelink: '/list?type=0&class=1&categoryId=02',
            }"
          >
            <ul class="z_list" style="padding: 0 16px 8px 14px">
              <li v-for="item in PlatformNews" :key="item.articleId">
                <router-link
                  :to="{
                    name: 'detail',
                    query: { articleId: item.articleId },
                  }"
                >
                  <span class="z_title"
                    ><span class="square">▪</span>
                    {{ item.title }}
                  </span>
                </router-link>
              </li>
            </ul>
          </z-card>

          <z-card
            style="margin-bottom: 10px; height: 224px"
            :titleparam="{
              iconname: 'nav_header7',
              iconclass: 'card-title',
              title: '近期开标',
              morelink: '/list?type=1&class=3',
            }"
          >
            <ul class="z_list" style="padding: 0 16px 8px 14px">
              <li v-for="item in OpenTender" :key="item.prjId">
                <router-link
                    :to="{
                      name: 'detail',
                      query: (item.ztbTypeId=='0207'||item.ztbTypeId=='0208'||item.ztbTypeId=='0210')?{type: 1,prjId:item.prjId}:{ bulletinId: item.bulletinId },
                    }"
                    target="_blank"
                  >
                <span class="z_title"
                  ><span class="square">▪</span>
                  {{ item.prjName }}
                </span>
                </router-link>
                <span class="time">{{ item.kbDate | moment("MM-DD") }}</span>
              </li>
            </ul>
          </z-card>
            <!-- href="https://blcq.nbcqjy.org/" -->
          <a
            href="http://ygcg.nbcqjy.org/fpthome?deptId=1011"
            target="_blank"
            :style="'width:392px;height:64.3px;display: inline-block;border: 1px solid #e8e8e8;margin-bottom:4px;background-image: url('+bgImg+');background-size: cover;background-repeat: no-repeat;color: white;text-align: center;line-height: 64.3px;font-size: 21px;letter-spacing: 4px;font-weight: bold;'"
          >
            阳光采购服务平台北仑分平台
          </a>
          <a
            href="http://ygcg.nbcqjy.org/fpthome?deptId=1012"
            target="_blank"
            :style="'width:392px;height:64.3px;display: inline-block;border: 1px solid #e8e8e8;margin-bottom:4px;background-image: url('+bgImg2+');background-size: cover;background-repeat: no-repeat;color: white;text-align: center;line-height: 64.3px;font-size: 21px;letter-spacing: 4px;font-weight: bold;'"
          >
            阳光采购服务平台江北分平台
          </a>
          <a
            href="http://ygcg.nbcqjy.org/fpthome?deptId=1013"
            target="_blank"
            :style="'width:392px;height:64.3px;display: inline-block;border: 1px solid #e8e8e8;margin-bottom:4px;background-image: url('+bgImg3+');background-size: cover;background-repeat: no-repeat;color: white;text-align: center;line-height: 64.3px;font-size: 21px;letter-spacing: 4px;font-weight: bold;'"
          >
            阳光采购服务平台前湾分平台
          </a>
          <a
            href="http://ygcg.nbcqjy.org/fpthome?deptId=1014"
            target="_blank"
            :style="'width:392px;height:64.3px;display: inline-block;border: 1px solid #e8e8e8;margin-bottom:4px;background-image: url('+bgImg5+');background-size: cover;background-repeat: no-repeat;color: white;text-align: center;line-height: 64.3px;font-size: 21px;letter-spacing: 4px;font-weight: bold;'"
          >
            阳光采购服务平台高新分平台
          </a>
          <a
            href="http://ygcg.nbcqjy.org/fpthome?deptId=1015"
            target="_blank"
            :style="'width:392px;height:64.3px;display: inline-block;border: 1px solid #e8e8e8;margin-bottom:4px;background-image: url('+bgImg6+');background-size: cover;background-repeat: no-repeat;color: white;text-align: center;line-height: 64.3px;font-size: 21px;letter-spacing: 4px;font-weight: bold;'"
          >
            阳光采购服务平台象山分平台
          </a>
          <a
            href="http://ygcg.nbcqjy.org/fpthome?deptId=1016"
            target="_blank"
            :style="'width:392px;height:64.3px;display: inline-block;border: 1px solid #e8e8e8;margin-bottom:4px;background-image: url('+bgImg7+');background-size: cover;background-repeat: no-repeat;color: white;text-align: center;line-height: 64.3px;font-size: 21px;letter-spacing: 4px;font-weight: bold;'"
          >
            阳光采购服务平台镇海分平台
          </a>
          <a
            href="http://ygcg.nbcqjy.org/fpthome?deptId=9998"
            target="_blank"
            :style="'width:392px;height:64.3px;display: inline-block;border: 1px solid #e8e8e8;margin-bottom:4px;background-image: url('+bgImg4+');background-size: 100% 280%;background-position: 0 -102px;background-repeat: no-repeat;color: white;text-align: center;line-height: 64.3px;font-size: 21px;letter-spacing: 2px;font-weight: bold;'"
          >
            阳光采购服务平台绿色采购专区
          </a>
          <!-- <a
            href="http://ygcg.nbcqjy.org:8062/"
            target="_blank"
            class="z_nav_img img_a"
          ></a> -->
          <!-- <a href="" class="z_nav_img img_b"></a> -->
          <!-- <a href="" class="z_nav_img z_ad_img"></a> -->
          <z-card
            style="margin-bottom: 10px; height: 224px"
            :titleparam="{
              iconname: '',
              iconclass: '',
              morelink: '/list?type=3&class=7',
            }"
            @cardbtncallback="tabchangeback"
          >
              <a-tabs :default-active-key="activeKey" @change="changeList" >
                <a-tab-pane key="1" tab="代理机构诚信专栏">
                  <ul class="z_list" style="padding: 0 16px 8px 14px">
                    <li v-for="item in Integrity" :key="item.articleId">
                      <span class="z_title"
                        ><span class="square">▪</span>
                        {{ item.customerName }}
                      </span>
                      <span class="right"
                        >
                        <span><span class="nb">{{ item.count_project }}</span> 宗</span>
                        <!-- <span v-if="listType=='2'"><span class="nb">{{ item.count_project }}</span> 宗</span> -->
                        <!-- <span v-else class="nb" style="color: rgb(121 121 121);">{{ item.grade }}</span> -->
                        </span>
                    </li>
                  </ul>
                </a-tab-pane>
                <a-tab-pane key="2" tab="供应商诚信专栏" force-render>
                  <ul class="z_list" style="padding: 0 16px 8px 14px">
                    <li v-for="item in CXrticleList" :key="item.articleId">
                      <router-link
                        :to="{
                          name: 'detail',
                          query: { articleId: item.articleId },
                        }"
                      >
                        <span class="z_title"
                          ><span class="square">▪</span>
                          {{ item.title }}
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </a-tab-pane>
              </a-tabs>
              
              <router-link :to="'/list?type=3&class=7&categoryId='+(activeKey=='1'?'1202':'1201')" style="color: rgb(191, 191, 191);position: absolute;top: 12px;right: 12px;"
                >查看更多 <svg-icon style="width: 18px;vertical-align: middle;margin-left: -8px;margin-top: -2px;" className="" icon-class="right"
              /></router-link>
          </z-card>

          <z-card
            style="
              height: 230px;
              border-radius: 2px 2px 0 0;
              margin-bottom: 10px;
            "
            :titleparam="{
              iconname: 'nav_header10',
              iconclass: 'card-title',
              title: '常见问题',
              morelink: '/list?type=0&class=5&categoryId=09&id=0901',
            }"
          >
          <!-- morelink: '/list?type=0&class=5&categoryId=04', -->
            <ul class="z_list" style="padding: 0 16px 8px 14px;">
              <li v-for="item in Question" :key="item.articleId">
                <router-link
                  :to="{
                    name: 'detail',
                    query: { articleId: item.articleId },
                  }"
                >
                  <span class="z_title"
                    ><span class="square">▪</span>
                    {{ item.title }}
                  </span>
                </router-link>
              </li>
            </ul>
          </z-card>

          <z-card
            style="height: 262px; border-radius: 0 0 2px 2px"
            :titleparam="{
              iconname: 'nav_header8',
              iconclass: 'card-title',
              title: '资料下载',
              morelink: '/list?type=0&class=5&categoryId=09',
            }"
          >
          <!--  morelink: '/list?type=0&class=6&categoryId=07', -->
            <ul class="z_list z_list_app" style="padding: 4px 16px 8px 14px">
              <li v-for="item in DownLoad" :key="item.articleId">
                <!-- 应用的图标img需要后台上传，前端自动获取 -->
                <!-- <img src="../../assets/app1.png" alt="" class="z_app_icon" /> -->
                <router-link
                  target="_blank"
                  :to="{
                    name: 'detail',
                    query: { articleId: item.articleId },
                  }"
                >
                  <span class="z_li">
                    <span class="z_title"> {{ item.title }} </span>
                    <svg-icon className="z_download" icon-class="download" />
                  </span>
                </router-link>
              </li>
            </ul>
          </z-card>
        </div>

        <div class="clear"></div>
      </div>
    </div>
    <div class="z-links">
      <div style="width: 1240px; padding: 0 16px; margin: auto">
        <div class="z_ad_link">
          <a v-for="item in advertisementList" :key="item.id" :href="item.url"
            ><img :src="item.imageUrl" alt=""
          /></a>
        </div>
        <!-- <div class="z_a">
          <span v-for="(item, i) in links" :key="item.id">
            <a :href="item.url">{{ item.title }}</a>
            <span v-if="i + 1 != links.length"> |</span>
          </span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import ZCard from "@/components/card";
import FloatWin from "@/components/FloatWin/FloatWin";
import bgImg from "../../assets/bg_1440_0_1011.png"
import bgImg2 from "../../assets/bg_1440_0_1012.png"
import bgImg3 from "../../assets/bg_qianwan.png"
// import bgImg4 from "../../assets/bg_lvse.png"
import bgImg4 from "../../assets/bg_1440_0_9998.png"
import bgImg6 from "../../assets/bg_1440_0_1015.jpg"
import bgImg7 from "../../assets/bg_1440_0_1016.jpg"
import bgImg5 from "../../assets/bg_1440_0_1014.jpg"

import {
  GetPortalInfo,
  GetPortalInfoList1,
  GetPortalInfoList2,
  GetPortalInfoList3,
  GetPortalInfoList4,
  GetBulletinList,
  GetPurchaseResults,
  GetBiddingHall,
} from "@/api/Home";
import {
  GetOtherList,
     GetIntegrityList
} from "@/api/protal";
import { mapMutations } from "vuex";

import { Carousel } from "ant-design-vue";
import { CountUp } from "countup.js";
import moment from "moment";
export default {
  name: "Countup",

  components: {
    ZCard,
    FloatWin,
    Carousel,
  },
  data() {
    return {
      bgImg:bgImg,
      bgImg2:bgImg2,
      bgImg3:bgImg3,
      bgImg4:bgImg4,
      bgImg5:bgImg5,
      bgImg6:bgImg6,
      bgImg7:bgImg7,
      btngroup: [
        { key: "21", name: "采购公告", active: true },
        { key: "23", name: "变更公告" },
        { key: "22", name: "中标候选公示" },
        { key: "20", name: "采购文件预公示" },
        { key: "28", name: "年度采购预公示" },
        // { key: "29", name: "流标公告" },
      ],
      tabgroup: [
        { key:"1", name: "代理" },
        { key:"2", name: "供应商" }
      ],
      btngroupbid: [
        { key: 1, name: "竞价采购公告", active: true, biddingType: 0 },
        // { key: 1, name: "电子询价", active: true, biddingType: 0 },
        // { key: 2, name: "电子竞价", biddingType: 1 },
        // { key: 3, name: "电子比选", biddingType: 2 },
        { key: 4, name: "竞价采购结果", biddingType: 3 },
      ],
      activeKey: '1',
      DZJGList:[],//电子监管
      BulletinList: [], // 公告
      biddingList: [], //竞价采购
      PlatformNews: [], //平台动态
      OpenTender: [], //今日开标
      Integrity: [], //诚信专栏
      CXrticleList: [], //诚信专栏
      Question: [], //常见问题
      DownLoad: [], //资料下载
      biddingType: 0,
      biddingResult: [],
      advertisementList: [], //广告
      links: [], //友情链接
      newsImgList: [], //新闻轮播图
      newsList: [], //新闻列表
      Statistics: {},
      NoticeType: 21,//公告类型classid
      WinShow:false, 
      Wintitle:'', 
      WinUrl:'',
      listType:'1'
    };
  },
  methods: {
    initCountUp() {
      let options = {
        startVal: 0,
      };
      let optiondecimal = {
        startVal: 0,
        decimalPlaces: 2,
      };
      let demo = new CountUp(
        this.$refs.countup,
        this.Statistics.count_member,
        options
      );
      let demo1 = new CountUp(
        this.$refs.countup1,
        this.Statistics.count_project,
        options
      );
      let demo2 = new CountUp(
        this.$refs.countup2,
        this.Statistics.count_money,
        optiondecimal
      );
      let demo3 = new CountUp(
        this.$refs.countup3,
        this.Statistics.count_savedMoney,
        optiondecimal
      );
      if (!demo.error && !demo1.error && !demo2.error && !demo3.error) {
        demo.start();
        demo1.start();
        demo2.start();
        demo3.start();
      } else {
        console.error(demo.error);
      }
    },

    ...mapMutations(["SET_NAV_NAME"]),
    GetPortalInfo() {
      let param = {};
      GetPortalInfo(param).then((res) => {
        // this.BulletinList = res.data.bulletinList_Purchase.bulletinList;
        // this.OpenTender = res.data.projectList_OpenTender.projectList;
        this.PlatformNews = res.data.articleList_02_PlatformNews.articleList;
        // this.newsImgList = res.data.newsImgList.body.data;
        // this.newsList = res.data.newsList.body.data;
        this.Wintitle = res.data.floatArticle.title;
        if(res.data.floatArticle.isFloat == "1"){
          this.WinShow = true;
        }
        this.WinUrl = '/detail?articleId='+res.data.floatArticle.articleId;
        // this.Integrity = res.data.integrityList.integrityList;
        this.Question = res.data.articleList_09_Question.articleList;
        this.DownLoad = res.data.articleList_07_File.articleList;
        // this.biddingList = res.data.biddingList_Project0207.projectList;
        // this.Statistics = res.data.hP_Statistics;
        // this.DZJGList = res.data.superviseLight;
        //console.log(res);
        // this.Statistics.count_money = (
        //   this.Statistics.count_money / 10000
        // ).toFixed(2);
        // this.Statistics.count_savedMoney = (
        //   this.Statistics.count_savedMoney / 10000
        // ).toFixed(2);
        // this.initCountUp();
        // this.advertisementList = res.data.advertisementList.advertisementList;
        // this.links = res.data.links.advertisementList;
      });
      GetPortalInfoList1(param).then((res) => {
        this.BulletinList = res.data.bulletinList_Purchase.bulletinList;
        this.newsImgList = res.data.newsImgList.body.data;
        this.newsList = res.data.newsList.body.data;
        this.biddingList = res.data.biddingList_Project0207.projectList;
        // this.initCountUp();
      });
      GetPortalInfoList2(param).then((res) => {
        this.OpenTender = res.data.projectList_OpenTender.projectList;
        this.DZJGList = res.data.superviseLight;
      });
      GetPortalInfoList3(param).then((res) => {
        this.Integrity = res.data.integrityList.integrityList;
        this.CXrticleList = res.data.articleList_02_PlatformNews.articleList;
        this.Statistics = res.data.hP_Statistics;
        this.advertisementList = res.data.advertisementList.advertisementList;
        this.links = res.data.links.advertisementList;
      });
      GetPortalInfoList4(param).then((res) => {
        this.Statistics = res.data.hP_Statistics;
        this.initCountUp();
      });
    },
    tabchangeback(key){
      this.listType = key
      var listParams = {
        pageIndex: 1,
        pageSize: 5
      }
      if(key == '1'){
        this.listParams.ssort = '';
        this.listParams.csort = '';
        GetIntegrityList(listParams).then((res) => {
          this.Integrity = res.data.integrityList;
        });
      }else{
        GetOtherList(listParams).then((res) => {
          this.Integrity = res.data.integrityList;
        });
      }
    },
    cardbtncallback(key) {
      let param = {};
      param.pageIndex = 1;
      param.pageSize = 15;
      param.classID = key;
      this.NoticeType = key;
      GetBulletinList(param).then((res) => {
        // console.log(res);
        this.BulletinList = res.data.bulletinList;
      });
    },
    biddingCallback(key, item) {
      this.biddingType = item.biddingType;
      let param = {};
      param.pageIndex = 1;
      param.pageSize = 6;
      param.classID = "22";
      if (item.biddingType != 3) {
        if (item.biddingType === 0) {
          param.ztbTypeId = "0000";//0207
        } else if (item.biddingType === 1) {
          param.ztbTypeId = "0208";
        } else if (item.biddingType === 2) {
          param.ztbTypeId = "0210";
        }
        this.biddingList = [];
        GetBiddingHall(param).then((res) => {
          this.biddingList = res.data.projectList;
        });
      } else {
        let _param = {};
        _param.pageIndex = 1;
        _param.pageSize = 15;
        GetPurchaseResults(_param).then((res) => {
          this.biddingResult = res.data;
        });
      }

      // console.log(item.biddingType);
    },
    getcountdown(kbDate) {
      //
      var date = moment(kbDate);
      var now = moment();
      let start = moment(new Date()); //获取开始时间
      let end = moment(new Date(kbDate)); //结束时间
      let result = {
        showcountdown: false,
      };
      if (now < date) {
        let diff = end.diff(start); //时间差
        let days = moment.duration(diff).days();
        let hours = moment.duration(diff).hours();
        let minutes = moment.duration(diff).minutes();
        result.days = days > 9 ? days : "0" + days;
        result.hours = hours;
        result.minutes = minutes;
        result.showcountdown = true;
        return result;
      } else {
        return result;
      }
    },
    getClass(ztbTypeId) {
      if (ztbTypeId === "0208") {
        return "D01";
      } else if (ztbTypeId === "0207") {
        return "D02";
      } else if (ztbTypeId === "0210") {
        return "D03";
      }
    },
    Offer(prjId) {
      window.open("http://ygcg.nbcqjy.org:8061/login.html?PrjId="+prjId, "_blank");
    },
    Bullet(prjId,biddingType) {
      this.$router.push({
        path: "/detail",
        query: biddingType=='0208'?{ type: 1, prjId: prjId, biddingType:1 }:{ type: 1, prjId: prjId },
      });
      // window.open("http://ygcg.nbcqjy.org:8059/Bulletin/bulletin.html?prjId="+prjId, "_blank");
    },
    Bullet2(prjId) {
      this.$router.push({
        path: "/detail",
        query: { type: 10, prjId: prjId },
      });
      // window.open("http://ygcg.nbcqjy.org:8059/Bulletin/bulletin.html?prjId="+prjId, "_blank");
    },
    changeList() {
      if(this.activeKey == '1'){
        this.activeKey = '2'
      }else{
        this.activeKey = '1'
      }
    }
  },
  mounted() {
    const query = this.$route.query;
    var deptId = query.deptId;
    if(deptId != null&&deptId !="undefined"){
      this.$router.push({
        path: "/fpthome",
        query: { deptId: deptId },
      });
    }
    // setInterval(() => {
    //   let result = this.getcountdown("2021-06-30");
    //   console.log(result);
    // }, 1000);

    this.GetPortalInfo();
    this.SET_NAV_NAME("首页");
  },
};
</script>
<style lang="less" scoped>
.bid-card:nth-child(3n) {
  border-right: none;
}
</style>
<style lang="less">
.red {
    background: red;
    background-size: 5px 5px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    box-shadow: 0 0 8px #666 inset, 0 0 18px red;
}

.yellow {
    background: yellow;
    background-size: 5px 5px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    box-shadow: 0 0 8px #666 inset, 0 0 18px #af9a0a;
}

.green {
    background: #00ff00;
    background-size: 5px 5px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    box-shadow: 0 0 8px #666 inset, 0 0 18px green;
    }
// .z_index{
//   .clear {
//     clear: both;
//   }
//   .z-content-left {
//     width: 800px;
//     float: left;
//   }

//   .z-content-right {
//     width: 392px;
//     height: 300px;
//     float: left;
//     margin-left: 16px;
//     .z_list {
//       li {
//         width: 100%;
//         height: 32px;
//         line-height: 32px;
//         overflow: hidden;
//       }
//       li:hover {
//         a {
//           .z_title {
//             color: #f5222d;
//           }
//         }
//       }
//       .z_title {
//         color: #262626;
//         display: inline-block;
//         width: 296px;
//         overflow: hidden;
//         white-space: nowrap;
//         text-overflow: ellipsis;
//         .square {
//           color: #8c8c8c;
//           margin-bottom: 2px;
//         }
//       }
//       .time {
//         float: right;
//         color: #8c8c8c;
//       }
//       .right {
//         float: right;
//         .nb {
//           font-weight: bold;
//         }
//       }
//     }
//     .z_nav_img {
//       display: inline-block;
//       width: 100%;
//       height: 104px;
//       border-radius: 2px;
//       margin-bottom: 12px;
//       background-color: #fafafa;
//       background-size: contain;
//       img {
//         width: 100%;
//         height: 100%;
//       }
//     }
//     .z_nav_img:hover {
//       box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.09);
//     }
//     .img_a {
//       background-image: url(../../assets/sider_nav_104a_2x.png);
//     }
//     .img_b {
//       background-image: url(../../assets/sider_nav_104b_2x.png);
//     }
//     .z_ad_img {
//       height: 136px;
//       background-image: url(../../assets/ad_sider_392_136_2x.png);
//     }
//     .z_list_app {
//       li {
//         height: 48px;
//         line-height: 48px;
//         overflow: hidden;
//         margin-bottom: 1px;
//         .z_app_icon {
//           width: 32px;
//           height: 32px;
//           margin-bottom: 18px;
//           margin-right: 8px;
//           vertical-align: middle;
//         }
//         .z_li {
//           width: 318px;
//           display: inline-block;
//           border-top: 1px solid #f0f0f0;
//           vertical-align: middle;
//           .z_title {
//             width: 276px;
//           }
//           .z_download {
//             float: right;
//             margin-top: 12px;
//             color: #f5222d;
//             fill: #f5222d;
//           }
//           .z_download:hover {
//             fill: #ff4d4f;
//           }
//         }
//       }
//       li:first-child {
//         .z_li {
//           border-top: 0;
//         }
//       }
//     }
//   }

//   .z-content-statistics {
//     height: 88px;
//     background: #ffffff;
//     border-radius: 2px;
//     border: 1px solid #e8e8e8;
//     margin-bottom: 16px;
//     ul {
//       display: flex;
//       justify-content: space-around;
//     }
//     li {
//       float: left;
//       height: 88px;
//       color: rgba(0, 0, 0, 0.65);
//       .statistics-item {
//         margin-top: 16px;
//       }
//     }
//   }
//   .z-content-entrance {
//     height: 86px;
//     margin-bottom: 16px;
//     .z-entrance {
//       li {
//         float: left;
//         width: 228px;
//         height: 86px;
//         img {
//           width: 100%;
//           cursor: pointer;
//         }
//       }
//       li:not(:first-child) {
//         margin-left: 17px;
//       }
//       li:hover {
//         box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
//       }
//     }
//   }

//   .z-links {
//     margin-top: 16px;
//     background: #f5f5f5;
//     margin-top: 24px;
//     .z_ad_link {
//       padding: 24px 0;
//       display: flex;
//       justify-content: space-between;
//       width: 100%;
//       a {
//         display: inline-block;
//         border-radius: 2px;
//         // width: 226px;
//         height: 80px;
//         background: #fafafa;
//         overflow: hidden;
//       }
//       a:hover {
//         box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
//       }
//       img {
//         width: 100%;
//         height: 80px;
//       }
//       span {
//         color: #e8e8e8;
//       }
//     }
//     .z_a {
//       color: #e8e8e8;
//       text-align: center;
//       padding-bottom: 24px;
//       a {
//         padding: 0 16px;
//         color: #595959;
//       }
//       a:hover {
//         color: #f5222d;
//       }
//     }
//   }
//   .bid-card {
//     position: relative;
//     box-sizing: border-box;
//     width: 266px;
//     height: 318px;
//     float: left;
//     border-right: 1px solid #e8e8e8;
//     border-bottom: 1px solid #e8e8e8;
//     .bid-card-container {
//       padding: 18px 14px 0 14px;
//       .bid-card-footer-price {
//         color: #ffffff;
//         width: 212px;
//         height: 40px;
//         background: linear-gradient(313deg, #fb6d7b 0%, #f63b45 100%);
//         border-radius: 8px 8px 0px 0px;
//         position: absolute;
//         bottom: 0;
//         left: 26px;

//         .pricespan {
//           font-size: 18px;
//           margin-left: 4px;
//         }
//         .price-div {
//           line-height: 40px;
//         }
//       }
//     }

//     .bid-card-head {
//       border-bottom: 1px solid rgba(0, 0, 0, 0.09);
//       .bid-card-alert {
//         margin-top: 8px;
//         margin-bottom: 16px;
//         width: 239px;
//         height: 24px;
//         background: rgba(24, 144, 255, 0.09);
//         border-radius: 16px;
//         font-size: 13px;
//         line-height: 24px;
//       }
//       .bid-card-prjname {
//         height: 44px;
//         display: -webkit-box;
//         -webkit-box-orient: vertical;
//         -webkit-line-clamp: 2;
//         overflow: hidden;
//       }
//     }
//     .bid-card-body {
//       margin-top: 8px;
//       font-size: 13px;
//       border-bottom: 1px solid rgba(0, 0, 0, 0.09);
//       li {
//         line-height: 22px;
//       }
//       ul {
//         margin-bottom: 8px;
//       }
//       .offer-count {
//         position: absolute;
//         bottom: 48px;
//       }
//     }
//     .bid-card-footer {
//       margin-top: 16px;

//       .bid-card-footer-countdown {
//         span {
//           margin-left: 4px;
//         }
//       }
//     }
//     .footer-time {
//       background: rgba(246, 59, 69, 0.09);
//       color: #f63b45;
//     }
//     .top-tag {
//       width: 72px;
//       height: 22px;
//       background: rgba(246, 59, 69, 0.09);
//       border-radius: 0px 0px 2px 2px;
//       margin: auto;
//       color: #f63b45;
//       text-align: center;
//       font-size: 13px;
//     }
//     .bid-card-footer-btn {
//       position: absolute;
//       width: 100%;
//       bottom: 1px;
//       left: 0;
//       button {
//         width: 100%;
//         height: 40px;
//         color: #f63b45;
//         background-color: #fff;
//         font-weight: bold;
//         border: none;
//         cursor: pointer;
//         border-top: 1px solid rgba(0, 0, 0, 0.09);
//       }
//       button:hover {
//         background-color: rgba(187, 183, 183, 0.09);
//       }
//     }
//   }
//   .bid-card:hover {
//     cursor: pointer;
//     box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.09);
//     z-index: 4;
//     .bid-card-footer-price {
//       box-shadow: 0 8px 32px 0 rgba(245, 34, 45, 0.3);
//     }
//   }
//   .catalogue {
//     color: #8c8c8c;
//     vertical-align: middle;
//   }
//   .catalogue_span {
//     vertical-align: middle;
//     overflow: hidden;
//     display: inline-block;
//     width: 156px;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//   }
//   .bid-card:nth-child(3n) {
//     border-right: none;
//   }
//   .bid-card:nth-child(n + 4) {
//     border-bottom: none;
//   }
//   .statistics-title {
//     color: rgba(0, 0, 0, 0.65);
//   }

//   .skewX {
//     width: 100px;
//     height: 24px;
//     background: #ffc53d;
//     transform: skewX(5deg);
//     border-radius: 5px;
//     position: absolute;
//     top: -8px;
//     right: 10px;
//     box-shadow: #442400 -5px 0 10px -5px;
//     div {
//       line-height: 24px;
//       transform: skewX(-5deg);
//       text-align: center;
//     }
//   }
// }
</style>
<style>
.ant-tabs-nav .ant-tabs-tab{
  margin-right: 0;
}
.news > .z-card-head {
  border-bottom: 1px solid #e8e8e8;
}
.slick-slide > div > div {
  background-color: #0d76cf;
}
.slick-slide > div {
  margin-top: 5px;
}
.ant-carousel .slick-slide img {
  /* height: 233px; */
  margin: auto;
  /* max-width: 350px; */
  width: 350px;
  /* width:400px; */
}
.ant-carousel .slick-slide img:not(:first-of-type) {
  display: none;
}
.ant-carousel .slick-slide p {
  display: none;
}

.ant-carousel .slick-dots li.slick-active button {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  margin-top: -10px;
}
.ant-carousel .slick-dots li button {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  margin-top: -10px;
  background-color: unset;
  border: solid;
  border: solid 1px;
  border-color: white;
  opacity: unset;
}
.ant-carousel .slick-dots-bottom {
  bottom: 12px;
  position: absolute;
  float: right;
  display: inline-block !important;
  width: auto;
  right: 5px;
}
</style>